import { getQueryPosition } from '~/store/queryPositionStore.ts';
import type { QueryKey } from '~/utils/queryKeys.ts';

export type ManipulatedQueryKey = [QueryKey[0], QueryKey[1], QueryKey[2]];

const custom = (key: QueryKey, position: number | undefined): ManipulatedQueryKey => {
    return [key[0], key[1], { ...(key[2] && typeof key[2] === 'object' ? key[2] : {}), position }];
};

const current = (key: QueryKey): ManipulatedQueryKey => {
    return [
        key[0],
        key[1],
        { ...(key[2] && typeof key[2] === 'object' ? key[2] : {}), position: getQueryPosition(JSON.stringify(key)) },
    ];
};

export const appendPositionToQueryKey = { current, custom };
